import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  constructor(private dataService: DataService) { }

  createCheckoutSession(userId: number, subscriptionId: number) {
    return this.dataService.createCheckoutSession(userId, subscriptionId);
  }

  createPortalSession(userId: number) {
    return this.dataService.createPortalSession(userId);
  }
}
